import classNames from 'classnames';

import styles from './IndexButton.module.css';

import { ButtonBase, type ButtonBaseProps } from '../ButtonBase';

export type IndexButtonVariant =
  | 'light'
  | 'dark'
  | 'darker'
  | 'green'
  | 'kale'
  | 'oyster';

export interface IndexButtonProps extends ButtonBaseProps {
  /** Required aria-label for buttons with no textual content */
  ['aria-label']: string;
  /** Indicate the current index is active */
  active: boolean;
  /** Optional class name */
  className?: string;
  /** Which variant to use. Default is `dark` */
  variant?: IndexButtonVariant;
}

/**
 * Render a small button that can be used to indicate the active index of a list
 * of items.
 *
 * @deprecated This component should be used (and later replaced) internally.
 * @see https://corgi-x.tfd.engineering/components/indexbutton
 */
export function IndexButton({
  active,
  variant = 'dark',
  className,
  ...props
}: IndexButtonProps) {
  return (
    <ButtonBase
      type="button"
      aria-pressed={active}
      className={classNames(
        styles.button,
        styles[variant],
        {
          [styles.active]: active,
        },
        className
      )}
      {...props}
    />
  );
}
